<template>
  <div class="main-container">
    <div class="pageLayout"> <pop-up-message
            v-if="showSuccessMsg"
            :message="`Payment has been initiated successfully `"
            btnText="Back"
            @back="backFromPopUp()"
          />
          
      <div class="headerSection">
        <img class="logoimg" src="@/assets/dashboard/HSBC_MASTER_LOGO.svg">
        <tl-header type="h3" class="head"></tl-header>
        <btn text="Download Report" type="primary" @click="download"  />
      </div>
      <div class="permission-alert-msg" v-show="alertMsgShow">
             {{ alertMsg}}
            </div>
            <div class="searchclass"><toast-message
              :message="errmsg"
              type="error"
              :isToastEnable="toast"
              @close="(val) => (toast = val)"
            /></div>
          
      <div class="tableSection">
        <data-table
          class="tableClass"
          :columns="PaymentColums"
          :tableData="PaymentData"
          :showinrow="true"
          @editStart="false"
          :showedit="false"
          :showdelete="false"
          :showhistory="false"
        >
          <template v-slot:rowcontent="slotprops">
            <p v-if="slotprops.value.column.key == 'employeeName'">
              {{ slotprops.value.record.empName }}
            </p>
            <p v-if="slotprops.value.column.key == 'paidDays'">
              {{ slotprops.value.record.paidDays }}
            </p>
            <p style='padding-left:160px' v-if="slotprops.value.column.key == 'netPay'">
              {{ numberFormate.format(slotprops.value.record.amount) }}
            </p>
            <p v-if="slotprops.value.column.key == 'paymentMode'">
              {{ "DirectDeposit" }}
            </p>
          </template>
        </data-table>
      </div>
      <div class="bottomSection">
        <div class="bottomHeader">
          <h3>Payment Remark</h3>
        </div>
        <div class="bottomHeader">
          
        <textarea v-model="textRemark" placeholder="Enter Remark here..."
        @change="(val)=>changeAlertMessageFunction()"></textarea>
          <!-- <p>
            (Salary) Salary is a fixed amount of money or compensation paid to
            an employee by an employer in return for work performed. (Salary)
            Salary is a fixed amount of money or compensation paid to an
            employee by an employer in return for work performed.
          </p> -->
          <btn
           :disabled="alertMsgShow"
            text="Initiate Payment"
            type="secondary"
            @click="createInitiatePayment"
          />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapActions, mapState, mapGetters } from "vuex";
import * as XLSX from 'xlsx';
const crypto = require("crypto");
export default {
  data() {
    return {
      toast:false,
      errmsg:"",
      numberFormate:"",
      alertMsg:"",
      alertMsgShow:false,
      month: "",
      currentMonth: "",
      clientCode: "",
      clientName:"",
      showSuccessMsg:false,
      PaymentData:[],
      textRemark:"",
      PaymentColums: [
        { label: "Employee Name", key: "employeeName" },
        { label: "Paid Days", key: "paidDays" },
        { label: "Net Pay(₹)", key: "netPay",style: 'padding-left:160px'},
        { label: "Payment Mode", key: "paymentMode" },
      ],
      PaymentDatass: [],
    };
  },
  computed: {
    ...mapGetters({
      getleid: "onboard/legal_entities/legal_entity_ID",
    }),
    ...mapState({
      payrollMonth: (state) => state.payroll.runpayroll.payrollMonth,
      payrollYear: (state) => state.payroll.runpayroll.payrollYear,
      entities: (state) => state.onboard.legal_entities.data,
    }),

    /* function get current month */
    getCurrentMonth() {
      try {
        this.month = this.payrollMonth ? this.payrollMonth : new Date();
        var today = new Date();
        this.currentMonth = today.getMonth();
        // this.getFormattedMonth(today);
      } catch (error) {
        this.toast = true;
        this.errmsg = error;
      }
    },
    leId() {
      this.numberFormate = new Intl.NumberFormat("en-in")
      if (this.$route.params.entity_index) {
        return this.getleid(this.$route.params.entity_index);
      }
      return this.getleid(0);
    },
  },
  mounted() {
    this.fetchHsbcPaymentData();
    this.getCurrentMonth();
  },
  methods: {
    ...mapActions({
      act_hsbc_payment_Details:
        "dashboard/hsbcPaymentSetting/fetchPaymentDetails",
      act_hsbc_payment_initiate:
        "dashboard/hsbcPaymentSetting/initiatePaymentDetails",
    }),
    backFromPopUp() {
      this.showSuccessMsg = false;
    },
    async changeAlertMessageFunction(){
          console.log("called")
         this.alertMsg=""
         this.alertMsgShow=false
    },
    async encryptData(payload) {
      try {
        const iv = crypto.randomBytes(8).toString("hex");
        const key = process.env.VUE_APP_PAYSLIP_SECRET;
        const cipher = crypto.createCipheriv("aes-256-cbc", key, iv);
        let encryptedText = Buffer.concat([
          cipher.update(JSON.stringify(payload)),
          cipher.final(),
        ]);
        return {
          iv: iv.toString(),
          encryptedPacket: encryptedText.toString("base64"),
        };
      } catch (err) {
        throw err;
      }
    },

    async decrypt(payload) {
      try {
        const key = process.env.VUE_APP_PAYSLIP_SECRET;
        const decipher = crypto.createDecipheriv(
          "aes-256-cbc",
          key,
          payload.iv
        );
        const decrypted = Buffer.concat([
          decipher.update(payload.encryptedPacket, "base64"),
          decipher.final(),
        ]);
        return decrypted.toString();
      } catch (error) {
      }
    },
    getLegalEntityName(value) {
      this.entities.map((item) => {
        if (value == item.id) {
          this.clientCode = item.clientCode;
          this.clientName = item.legalName
        }
      });
    },
    async fetchHsbcPaymentData() {
      try {
        await this.getLegalEntityName(this.leId);
        console.log(this.leId)
        let obj = {
          payMonth: this.month,
          paymentYear: this.payrollYear,
          clientCode: this.clientCode,
          legalEntityId: this.leId,
        };
      
        let data = await this.encryptData(obj);
        let res = await this.act_hsbc_payment_Details(data);
        let apiResponse = JSON.parse(await this.decrypt(res.data));
        console.log(apiResponse)
        this.PaymentData = apiResponse.data;
      } catch (err) {
      }
    },
    async download(){
      console.log(this.clientName)
        const data = XLSX.utils.json_to_sheet(this.PaymentData)
        const wb = XLSX.utils.book_new()
        XLSX.utils.book_append_sheet(wb, data, 'data')
        XLSX.writeFile(wb,`${this.clientName}.xlsx`)
      },
  async createInitiatePayment() {
    try {
      if(this.textRemark){
        for(let i in this.PaymentData){
        this.PaymentData[i] = {
          ...this.PaymentData[i],
          slNo:+i+1,
          bankAccountName:this.PaymentData[i].empName,
          clientName:this.clientName
        }
      }
     
      let payment_Initiate= {comment:this.textRemark,
        createdUserId: "",
        createdUserIp: "",
        data:this.PaymentData}
      
      let data = await this.encryptData(payment_Initiate);
      let res = await this.act_hsbc_payment_initiate(data);
      let apiResponse = JSON.parse(await this.decrypt(res.data));
      console.log(apiResponse)
              if(apiResponse.success){
               this. showSuccessMsg=true
              }else{
                this.toast=true,
                this.errmsg = apiResponse .message
              }
      }
      else{
         this.alertMsg="Payment Remark field is mandatory"
         this.alertMsgShow=true
      }
    } catch {
      
    }
  },
 },
};
</script>
<style lang="scss" scoped>
.logoimg{
  height: 80px;
  width: 120px;
  padding-right: 2px;
}

.headerSection {
  display: flex;
  justify-content: space-between;
}
.tableSection {
  margin-top: 20px;
  overflow: hidden;
}
.bottomHeader {
  display: flex;
  justify-content: space-between;
  margin-top: 30px;
  align-items: center;
  p {
    background-color: rgb(236, 236, 244);
    padding: 20px;
    margin-right: 10px;
  }
}
.bottomSection {
  margin-top:0rem;
}
.head {
  margin-right: 30px;
  margin-bottom:15px;
  
}
textarea{
  width: 100%;
  height: 60px;
  margin-right:10px ;
  padding:10px;
  border:1px solid  #34c0be;
  background-color: #f0f1f5;
}

</style>
